export const notApplicable = 'N/A';
export const dealFieldCustomer = 'CUSTOMER';
export const dealFieldName = 'DEAL NAME';
export const dealFieldPeriod = 'PERIOD';

export const dealFieldUpliftOverBatna = 'UPLIFT OVER BATNA 1';
export const dealFieldHeadlineSize = 'BASE HEADLINE SIZE';
export const dealFieldVolume = 'BASE VOLUME';

export const REVENUE = 'Revenue';
export const BASE_PRICE_FORMULA = 'Base price formula';
export const CAPS = 'Caps';
export const FLOORS = 'Floors';
export const REIMBURSED_SUPPLY_COST = 'Reimbursed supply cost';
export const NETBACK = 'Netback';
export const PUSH = 'Push';
export const PULL = 'Pull';
export const EXTENSION = 'Extension';
export const EARLY_TERMINATION = 'Early termination';
export const VARIABLE_SUPPLY_COST = 'Variable supply cost';
export const ANNUAL_FIXED_SUPPLY_COST = 'Annual fixed supply cost';
export const CAPITAL_COST_INVENTORY = 'Capital cost of incremental inventory';
export const CAPITAL_COST_TRANSIT_INVENTORY = 'Capital cost of additional inventory in transit';
export const CAPITAL_COST_PAYMENT = 'Capital cost of non-standard payment days';
export const EXPECTED_COST = 'Expected cost of probability of default';
export const MARGIN = 'Margin';
export const VARIABLE_MANUFACTURING_COST = 'Variable manufacturing cost';
export const COST_TO_SERVE_YIELD = 'Cost-to-Serve Yield';
export const EXCLUDING_TEXT = '(excluding: capital costs & probability of default )';
export const VARIABLE_FIXED_TEXT = 'Variable & Fixed supply cost';
